export default __webpack_public_path__ + "static/media/contact-1.0f20c039.png";